export const SYSTEM_MEASURE = {
  METRIC: 'metric',
  IMPERIAL: 'imperial',
  get: type => {
    return (type === SYSTEM_MEASURE.IMPERIAL) ? SYSTEM_MEASURE.IMPERIAL : SYSTEM_MEASURE.METRIC;
  }
};
